<template>
  <div id="dynamic-date-picker-field">
    <div v-if="parseInt(fieldProperties.field_property.display_type) == 1">
      <label
        :for="`input-${fieldProperties.key}`"
        :style="styleProperty"
        :class="fieldProperties.required ? 'required' : null"
      >
        {{
          $i18n.locale == "th"
            ? fieldProperties.label_th
            : fieldProperties.label_en
        }}
      </label>
      <div class="d-flex align-items-center">
        <div class="p-relative mr-1" :style="fieldStyleProperty">
          <calendar-picker-icon
            class="icon-calendar bypass"
            :class="fieldValue.date ? 'date-selected-icon' : null"
          />
          <flat-pickr
            :id="`input-${fieldProperties.key}`"
            class="form-control  bg-date"
            :class="fieldValue.date ? 'date-selected' : null"
            :config="
              fieldProperties.required
                ? flatpickrDateConfig
                : {
                    altFormat: 'F j, Y',
                    dateFormat: 'd-m-Y',
                    disableMobile: true,
                  }
            "
            :placeholder="
              $i18n.locale == 'th'
                ? fieldProperties.placeholder_th
                : fieldProperties.placeholder_en
            "
            :style="{ ...fieldStyleProperty, width: '100%' }"
            :required="fieldProperties.required"
            autocomplete="off"
            v-model="fieldValue.date"
          />
        </div>
      </div>
    </div>
    <div v-if="parseInt(fieldProperties.field_property.display_type) == 2">
      <label
        :for="`input-${fieldProperties.key}`"
        :style="styleProperty"
        :class="fieldProperties.required ? 'required' : null"
      >
        {{
          $i18n.locale == "th"
            ? fieldProperties.label_th
            : fieldProperties.label_en
        }}
      </label>
      <div class="d-flex">
        <div class="p-relative w-100" :style="fieldStyleProperty">
          <clock-picker-icon
            class="icon-calendar bypass"
            :class="fieldValue.time ? 'date-selected-icon' : null"
          />
          <flat-pickr
            :id="`input-${fieldProperties.key}`"
            class="form-control  bg-date"
            :class="fieldValue.time ? 'date-selected' : null"
            :style="{ ...fieldStyleProperty, width: '100%' }"
            :config="
              fieldProperties.required
                ? flatpickrTimeConfig
                : {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                  }
            "
            :placeholder="'HH : mm'"
            :required="fieldProperties.required"
            autocomplete="off"
            v-model="fieldValue.time"
          />
        </div>
      </div>
    </div>

    <div v-if="parseInt(fieldProperties.field_property.display_type) == 3">
      <label
        :for="`input-${fieldProperties.key}`"
        :style="styleProperty"
        :class="fieldProperties.required ? 'required' : null"
      >
        {{
          $i18n.locale == "th"
            ? fieldProperties.label_th
            : fieldProperties.label_en
        }}
      </label>
      <div class="d-flex">
        <div class="p-relative mr-1" :style="fieldStyleProperty">
          <calendar-picker-icon
            class="icon-calendar bypass"
            :class="fieldValue.date ? 'date-selected-icon' : null"
          />
          <flat-pickr
            :id="`input-${fieldProperties.key}`"
            class="form-control  bg-date"
            :class="fieldValue.date ? 'date-selected' : null"
            :config="
              fieldProperties.required
                ? flatpickrDateConfig
                : {
                    altFormat: 'F j, Y',
                    dateFormat: 'd-m-Y',
                    disableMobile: true,
                  }
            "
            :placeholder="
              $i18n.locale == 'th'
                ? fieldProperties.placeholder_th
                : fieldProperties.placeholder_en
            "
            :style="{ ...fieldStyleProperty, width: '100%' }"
            :required="fieldProperties.required"
            autocomplete="off"
            v-model="fieldValue.date"
          />
        </div>
        <div class="custom-width p-relative w-25">
          <clock-picker-icon
            class="icon-calendar date-picker-icon bypass"
            :class="fieldValue.time ? 'date-selected-icon' : null"
          />
          <flat-pickr
            :id="`input-${fieldProperties.key}`"
            class="form-control bg-date"
            :class="fieldValue.time ? 'date-selected' : null"
            :style="{ ...fieldStyleProperty, width: '100%' }"
            :config="
              fieldProperties.required
                ? flatpickrTimeConfig
                : {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    disableMobile: true,
                  }
            "
            :placeholder="'HH : mm'"
            :required="fieldProperties.required"
            autocomplete="off"
            v-model="fieldValue.time"
          />
        </div>
      </div>
    </div>
    <div v-if="parseInt(fieldProperties.field_property.display_type) == 4">
      <div class="d-flex">
        <div class="w-100">
          <label
            :for="`input-${fieldProperties.key}-start`"
            :style="styleProperty"
            :class="fieldProperties.required ? 'required' : null"
          >
            {{
              $i18n.locale == "th"
                ? fieldProperties.field_property.start_date.label_th
                : fieldProperties.field_property.start_date.label_en
            }}
          </label>
          <div class="d-flex align-items-center w-100">
            <div
              class="p-relative mr-1"
              :style="{
                width:
                  fieldProperties.field_property.width || datePickerField.width,
              }"
              v-if="fieldProperties.field_property.date_required"
            >
              <calendar-picker-icon
                class="icon-calendar bypass"
                :class="fieldValue.date ? 'date-selected-icon' : null"
              />
              <flat-pickr
                :id="`input-${fieldProperties.key}-start`"
                class="form-control  bg-date"
                :class="fieldValue.date ? 'date-selected' : null"
                :config="
                  fieldProperties.required
                    ? flatpickrDateConfig
                    : {
                        altFormat: 'F j, Y',
                        dateFormat: 'd-m-Y',
                        disableMobile: true,
                      }
                "
                :placeholder="
                  $i18n.locale == 'th'
                    ? fieldProperties.placeholder_th
                    : fieldProperties.placeholder_en
                "
                :style="fieldStyleProperty"
                :required="fieldProperties.required"
                autocomplete="off"
                v-model="fieldValue.range.startDate.date"
              />
            </div>
            <div
              class="p-relative"
              v-if="fieldProperties.field_property.time_required"
            >
              <clock-picker-icon
                class="icon-calendar date-picker-icon bypass"
                :class="fieldValue.time ? 'date-selected-icon' : null"
              />
              <flat-pickr
                :id="`input-${fieldProperties.key}-start`"
                class="form-control bg-date"
                :class="fieldValue.time ? 'date-selected' : null"
                :style="fieldStyleProperty"
                :config="
                  fieldProperties.required
                    ? flatpickrTimeConfig
                    : {
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: 'H:i',
                      }
                "
                :placeholder="'HH : mm'"
                :required="fieldProperties.required"
                autocomplete="off"
                v-model="fieldValue.range.startDate.time"
              />
            </div>
            <div class="mx-1 range-divider">{{ "To" }}</div>
          </div>
        </div>
        <div class="w-100">
          <label
            :for="`input-${fieldProperties.key}-end`"
            :style="styleProperty"
            :class="fieldProperties.required ? 'required' : null"
          >
            {{
              $i18n.locale == "th"
                ? fieldProperties.field_property.end_date.label_th
                : fieldProperties.field_property.end_date.label_en
            }}
          </label>
          <div class="d-flex w-100">
            <div
              class="p-relative mr-1"
              :style="{
                width:
                  fieldProperties.field_property.width || datePickerField.width,
              }"
              v-if="fieldProperties.field_property.date_required"
            >
              <calendar-picker-icon
                class="icon-calendar bypass"
                :class="fieldValue.date ? 'date-selected-icon' : null"
              />
              <flat-pickr
                :id="`input-${fieldProperties.key}-start`"
                class="form-control  bg-date"
                :class="fieldValue.date ? 'date-selected' : null"
                :config="
                  fieldProperties.required
                    ? flatpickrDateConfig
                    : {
                        altFormat: 'F j, Y',
                        dateFormat: 'd-m-Y',
                        disableMobile: true,
                      }
                "
                :placeholder="
                  $i18n.locale == 'th'
                    ? fieldProperties.placeholder_th
                    : fieldProperties.placeholder_en
                "
                :style="fieldStyleProperty"
                :required="fieldProperties.required"
                autocomplete="off"
                v-model="fieldValue.range.endDate.date"
              />
            </div>
            <div
              class="p-relative"
              v-if="fieldProperties.field_property.time_required"
            >
              <clock-picker-icon
                class="icon-calendar date-picker-icon bypass"
                :class="fieldValue.time ? 'date-selected-icon' : null"
              />
              <flat-pickr
                :id="`input-${fieldProperties.key}-start`"
                class="form-control bg-date"
                :class="fieldValue.time ? 'date-selected' : null"
                :style="fieldStyleProperty"
                :config="
                  fieldProperties.required
                    ? flatpickrTimeConfig
                    : {
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: 'H:i',
                      }
                "
                :placeholder="'HH : mm'"
                :required="fieldProperties.required"
                autocomplete="off"
                v-model="fieldValue.range.endDate.time"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BCardHeader } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";

import Ripple from "vue-ripple-directive";
import { computed, reactive, watch, onBeforeMount } from "@vue/composition-api";
import { datePickerField } from "@/configs/dynamic-config/dynamic-field";

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    ClockPickerIcon,
    CalendarPickerIcon,
    BCardHeader,
    flatPickr,
  },
  props: { fieldProperties: Object },

  setup(props) {
    const fieldValue = reactive({
      date: null,
      time: null,
      range: {
        startDate: { date: null, time: null },
        endDate: { date: null, time: null },
      },
    });

    const styleProperty = computed(() => {
      return {
        color:
          props.fieldProperties.field_property.color_font ||
          datePickerField.color_font,
        fontSize:
          props.fieldProperties.field_property.font_size ||
          datePickerField.fontSize,
      };
    });

    const fieldStyleProperty = computed(() => {
      return {
        color:
          props.fieldProperties.field_property.color_font ||
          datePickerField.color_font,
        fontSize:
          props.fieldProperties.field_property.font_size ||
          datePickerField.fontSize,
        height: props.fieldProperties.field_property.height,
        width:
          props.fieldProperties.field_property.width || datePickerField.width,
      };
    });

    const flatpickrDateConfig = {
      allowInput: true,
      altFormat: "F j, Y",
      dateFormat: "d-m-Y",
      disableMobile: true,
      onReady: function(selectedDates, dateStr, instance) {
        let el = instance.element;

        const preventInput = (event) => {
          event.preventDefault();
          return false;
        };

        el.onkeypress = preventInput;
        el.onkeydown = preventInput;
        el.onkeyup = preventInput;
        el.onpaste = preventInput;
        el.style.caretColor = "transparent";
        el.style.cursor = "pointer";
      },
    };

    const flatpickrTimeConfig = {
      allowInput: true, // prevent "readonly" prop
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      disableMobile: true,
      minuteIncrement: 1,
      dateFormat: "H:i",
      onReady: function(selectedDates, dateStr, instance) {
        let el = instance.element;

        const preventInput = (event) => {
          event.preventDefault();
          return false;
        };

        el.onkeypress = preventInput;
        el.onkeydown = preventInput;
        el.onkeyup = preventInput;
        el.onpaste = preventInput;
        el.style.caretColor = "transparent";
        el.style.cursor = "pointer";
      },
    };

    const initFieldValue = (dateObject, rangeMode = false) => {
      if (rangeMode) {
        const startDate = dateObject.field_property.start_date.value
          ? new Date(dateObject.field_property.start_date.value)
          : null;
        const endDate = dateObject.field_property.end_date.value
          ? new Date(dateObject.field_property.end_date.value)
          : null;

        if (dateObject.field_property.date_required) {
          const startDateStr = startDate
            ? `${startDate.toLocaleString("default", {
                day: "2-digit",
              })}-${startDate.toLocaleString("default", {
                month: "2-digit",
              })}-${startDate.getFullYear()}`
            : "";

          const endDateStr = endDate
            ? `${endDate.toLocaleString("default", {
                day: "2-digit",
              })}-${endDate.toLocaleString("default", {
                month: "2-digit",
              })}-${endDate.getFullYear()}`
            : "";

          fieldValue.range.startDate.date = startDateStr;
          fieldValue.range.endDate.date = endDateStr;
        }

        if (dateObject.field_property.time_required) {
          const startHours = startDate ? startDate.getHours() : null;
          const startMinutes = startDate ? startDate.getMinutes() : null;
          const endHours = endDate ? endDate.getHours() : null;
          const endMinutes = endDate ? endDate.getMinutes() : null;

          const startTimeStr =
            startHours && startMinutes
              ? `${startHours < 10 ? `0${startHours}` : startHours}:${
                  startMinutes < 10 ? `0${startMinutes}` : startMinutes
                }`
              : "";

          const endTimeStr =
            endHours && endMinutes
              ? `${endHours < 10 ? `0${endHours}` : endHours}:${
                  endMinutes < 10 ? `0${endMinutes}` : endMinutes
                }`
              : "";

          fieldValue.range.startDate.time = startTimeStr;
          fieldValue.range.endDate.time = endTimeStr;
        }

        return;
      }

      if (dateObject.value) {
        const date = new Date(dateObject.value);

        const dateStr = `${date.toLocaleString("default", {
          day: "2-digit",
        })}-${date.toLocaleString("default", {
          month: "2-digit",
        })}-${date.getFullYear()}`;

        const hours = date.getHours();
        const minutes = date.getMinutes();

        const timeStr = `${hours < 10 ? `0${hours}` : hours}:${
          minutes < 10 ? `0${minutes}` : minutes
        }`;

        fieldValue.date = dateStr;
        fieldValue.time = timeStr;
      }
    };

    onBeforeMount(() => {
      initFieldValue(
        props.fieldProperties,
        props.fieldProperties.field_property.display_type == 4
      );
    });

    watch(
      () => props.fieldProperties,
      () => {
        initFieldValue(
          props.fieldProperties,
          props.fieldProperties.field_property.display_type == 4
        );
      },
      { deep: true }
    );

    return {
      styleProperty,
      datePickerField,
      fieldValue,
      fieldStyleProperty,
      flatpickrTimeConfig,
      flatpickrDateConfig,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

#generate-report-custom .custom-width,
#generate-report .custom-width {
  width: auto !important;
}
</style>
